import { useState, useEffect } from "react";
import { HandySvg } from 'handy-svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross.svg';
import stepByStepBanner from '../../assets/images/banners/stepByStepBanner.png';
import { user, feedback } from '../../lib/api/api';

const Banner90Days = ({finalSlide}) => {
    const [userName, setUserName] = useState("");
    const [userMobile, setUserMobile] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [banner, setBanner] = useState(true);
    const [loading, setLoading] = useState(true);
    const [visibleButton, setVisibleButton] = useState(false);
    const [payment, setPayment] = useState(true);
    const [URL, setURL] = useState('');

    useEffect(() => {
        user.userInfo()
            .then((res) => {
                setUserName(res.name);
                setUserMobile(res.mobile);
                setUserEmail(res.email);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        if (userName && userMobile && userEmail) {
            submitForm();
        }
    }, [userName, userMobile, userEmail]);

    useEffect(() => {
        if (visibleButton) {
            nextBtn();
        }
    }, [visibleButton]);

    function submitForm() {
        const formElement = document.getElementById('banner90Days');
        if (formElement) {
            formElement.addEventListener('submit', (e) => {
                e.preventDefault();
                setBanner(false);
                feedback.tkoAction(userName, mobileTransformation(userMobile), userEmail, 1, 1, 1)
                    .then((res) => {
                        setVisibleButton(true);
                        if (res.success.url) {
                            setURL(res.success.url);
                        } else {
                            setPayment(false);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setPayment(false);
                    });
            });
        }
    }

    function nextBtn() {
        const element = document.getElementById('loadingBtn');
        element.addEventListener('click', () => {
            setLoading(false);
        });
    }

    function mobileTransformation(mobile) {
        let result = mobile.replace(/[^0-9]/g,"");
        if ((result.slice(0, 1)) === '8') {
            return `+7 (${result.slice(1, 4)}) ${result.slice(4, 7)}-${result.slice(7)}`;
        } else if ((result.slice(0, 1)) === '7') {
            return `+${result.slice(0, 1)} (${result.slice(1, 4)}) ${result.slice(4, 7)}-${result.slice(7)}`;
        } else {
            return `+7 (${result.slice(0, 3)}) ${result.slice(3, 6)}-${result.slice(6)}`;
        }
    }

    return (
        <>
            <section className="step-by-step-banner page__step-banner js-closing-banner" style={userName && userMobile && userEmail ? {display: 'none'} : {display: 'none'}}>
                <h6 className="visuallyhidden">Рекламный баннер</h6>
                <div className="step-by-step-banner__inner page-container">
                    {finalSlide ? (
                        <div className="step-by-step-banner__wrapper">
                            <div className="step-by-step-banner__pic-wrap">
                                <img className="step-by-step-banner__img" alt="Подарки всем!" width="auto" height="auto" src={stepByStepBanner}/>
                            </div>
                            <div className="step-by-step-banner__info-container">
                                <div className="step-by-step-banner__text">
                                    <span className="step-by-step-banner__title">Акция Подключена, перейти в онлайн-кинотеатр Телекарта?</span>
                                </div>
                                <a href='https://onlinetv.telekarta.tv/' target="_blank" rel="noopener noreferrer" className='step-by-step-banner__btn bttn solid-btn solid-btn--blue'>Смотреть</a>
                            </div>
                        </div>
                    ) :
                    banner ? (
                        <form id="banner90Days">
                            <div className="step-by-step-banner__wrapper">
                                <div className="step-by-step-banner__pic-wrap">
                                    <img className="step-by-step-banner__img" alt="Подарки всем!" width="auto" height="auto" src={stepByStepBanner}/>
                                </div>
                                <div className="step-by-step-banner__info-container">
                                    <div className="step-by-step-banner__text">
                                        <span className="step-by-step-banner__title">90 дней кино и развлечения в телекарте за 1₽</span>
                                        <div className="step-by-step-banner__description">
                                            <p>Три месяца подписки «Кино и Развлечения» и эфирные каналы в онлайн-кинотеатре «Телекарта» — всего за 1₽!</p>
                                        </div>
                                    </div>
                                    <button className='step-by-step-banner__btn bttn solid-btn solid-btn--blue' type='submit'>Подключить</button>
                                </div>
                            </div>
                        </form>
                    ) :
                    loading ? (
                        <div className="step-by-step-banner__container">
                            <div className="step-by-step-banner__message">
                                <span className="step-by-step-banner__title">Создаем заявку на подключение акции</span>
                            </div>
                            {visibleButton ? (
                                <button className='step-by-step-banner__btn bttn solid-btn solid-btn--blue' type='button' id="loadingBtn">Далее</button>
                            ) : (
                                <button className='step-by-step-banner__btn bttn solid-btn solid-btn--blue' type='button' disabled>Далее</button>
                            )}
                        </div>
                    ) :
                    payment ? (
                        <div className="step-by-step-banner__block">
                            <div className="step-by-step-banner__instruction">
                                <span className="step-by-step-banner__title">Акция «90 дней кино и развлечения в телекарте за 1₽»</span>
                                <div className="step-by-step-banner__list">
                                    <span className="step-by-step-banner__list-title">Для подключения акции:</span>
                                    <ul className="step-by-step-banner__list-text">
                                        <li>Оплатите 1 рубль</li>
                                        <li>Смотри ТВ вместе с онлайн-кинотеатром «Телекарта»!</li>
                                    </ul>
                                </div>
                            </div>
                            <a href={URL} rel="noopener noreferrer" className='step-by-step-banner__btn bttn solid-btn solid-btn--blue'>Оплатить 1 рубль</a>
                        </div>
                    ) : (
                        <div className="step-by-step-banner__container">
                            <div className="step-by-step-banner__error">
                                <span className="step-by-step-banner__title">Извините, в данный момент невозможно выполнить платёж! Повторите попытку позднее</span>
                            </div>
                        </div>
                    )}
                    <button className="step-by-step-banner__close-btn js-close-btn" type="button">
                        <HandySvg className="svg-icon" src={iconCross} width="12" height="12"/>
                    </button>
                </div>
            </section>
        </>
    );
};

export default Banner90Days;